export const NODE_RADIUS = 20;
export const NODE_LABEL_Y_OFFSET = 15;
